import { render, staticRenderFns } from "./MakeinReportDetail.vue?vue&type=template&id=befa34e2"
import script from "./MakeinReportDetail.vue?vue&type=script&lang=js"
export * from "./MakeinReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports